module.exports = __webpack_public_path__ + "st.svg?a9db5b501b31b4e456d822975fb8bd7b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/st.svg
// module id = 1191
// module chunks = 27